import { useTheme } from '../theme/ThemeContext'

export default function BackgroundGradient() {
  const { theme } = useTheme()
  const isLight = theme === 'light'

  if (isLight) {
    return (
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(135deg, #fff5ef 0%, #fde4e6 40%, #fbd0d5 75%, #f3b6c0 100%)',
          }}
        />
        <div
          className="absolute -top-32 -right-32 w-[1100px] h-[1100px] rounded-full blur-3xl opacity-70"
          style={{
            background: 'radial-gradient(closest-side, rgba(213,72,94,0.45), rgba(213,72,94,0))',
          }}
        />
        <div
          className="absolute top-[20%] left-[40%] w-[900px] h-[900px] rounded-full blur-3xl opacity-60"
          style={{
            background:
              'radial-gradient(closest-side, rgba(255,196,158,0.45), rgba(255,196,158,0))',
          }}
        />
        <div
          className="absolute bottom-[-200px] right-[-100px] w-[900px] h-[900px] rounded-full blur-3xl opacity-65"
          style={{
            background: 'radial-gradient(closest-side, rgba(191,43,70,0.4), rgba(191,43,70,0))',
          }}
        />
        <div
          className="absolute bottom-[-150px] left-[-150px] w-[700px] h-[700px] rounded-full blur-3xl opacity-45"
          style={{
            background: 'radial-gradient(closest-side, rgba(196,181,253,0.4), rgba(196,181,253,0))',
          }}
        />
      </div>
    )
  }

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      <div className="absolute inset-0 bg-[#0b1226]" />
      <div
        className="absolute -top-32 -right-32 w-[900px] h-[900px] rounded-full blur-3xl opacity-70"
        style={{
          background: 'radial-gradient(closest-side, rgba(191,43,70,0.45), rgba(191,43,70,0))',
        }}
      />
      <div
        className="absolute top-[35%] left-[30%] w-[900px] h-[900px] rounded-full blur-3xl opacity-65"
        style={{
          background: 'radial-gradient(closest-side, rgba(168,85,247,0.35), rgba(168,85,247,0))',
        }}
      />
      <div
        className="absolute bottom-[-200px] left-[-200px] w-[800px] h-[800px] rounded-full blur-3xl opacity-60"
        style={{
          background: 'radial-gradient(closest-side, rgba(34,211,238,0.32), rgba(34,211,238,0))',
        }}
      />
      <div
        className="absolute top-[20%] right-[10%] w-[500px] h-[500px] rounded-full blur-3xl opacity-50"
        style={{
          background: 'radial-gradient(closest-side, rgba(244,114,182,0.28), rgba(244,114,182,0))',
        }}
      />
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-slate-950/80 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-slate-950/40 to-transparent" />
    </div>
  )
}
